import React from "react";
import useObjectUrl from "../hooks/useObjectUrl";

export default function FileViewer({ file, page, embedded = false }) {
  const url = useObjectUrl(file?.blob);
  if (!file) return null;
  return (
    <section
      className={
        embedded ? "premium-viewer" : "card premium-panel premium-viewer"
      }
      aria-label={file.name}
    >
      <div className="premium-toolbar">
        <h2>{file.name}</h2>
        <a href={url} download={file.name} className="btn btn-outline-primary">
          Pobierz
        </a>
      </div>
      {url &&
        (file.blob.type.startsWith("image/") ? (
          <img src={url} alt={file.name} />
        ) : (
          <iframe
            title={file.name}
            src={`${url}${page ? `#page=${page}` : ""}`}
          />
        ))}
    </section>
  );
}
